$mol_form $mol_list
	submit_allowed true
	submit_blocked false
	event *
		^
		keydown? <=> keydown? null
	save? null
	message_done @ \Saved
	errors *string
		\Form invalid
			<= form_invalid @ \Form is not valid
	rows /
		<= Body $mol_list
			sub <= body <= form_fields /$mol_form_field
		<= Foot $mol_row
			sub <= foot <= buttons /$mol_view
				<= Submit $mol_button_major
					title <= submit_title @ \Save
					hint <= submit_hint \
					activate? => submit_activate?
					click? <=> submit? null
				<= Result $mol_status
					message <= result? null
